module.exports = __webpack_public_path__ + "media/icons/task-tick-gray-e6e94db7.png";